import { InputHTMLAttributes } from 'react'

function RadioButton({
  label,
  onChange,
  ...props
}: RadioButtonProps & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <div className="flex items-center justify-start">
      <label className="space-x-2 cursor-pointer">
        <input
          className="w-4 h-4 border-2 border-gray-100 rounded-lg appearance-none cursor-pointer hover:bg-gradient-to-b hover:border-0 hover:from-sbtviolet-400 hover:to-sbtviolet-500 checked:bg-sbtviolet-500 checked:border-none"
          type="radio"
          onChange={onChange}
          {...props}
        />
        <span className="text-gray-150 text-md">{label}</span>
      </label>
    </div>
  )
}

interface RadioButtonProps {
  label: string
  onChange: () => void
}

export default RadioButton
